import React from "react"
import { Helmet } from "react-helmet"
import CssBaseline from "@material-ui/core/CssBaseline"
import { ThemeProvider } from "@material-ui/core/styles"
import theme from "../../src/theme"

export default function TopLayout(props) {
  return <React.Fragment>{props.children}</React.Fragment>
}
